import { render, staticRenderFns } from "./UnitWrapper.vue?vue&type=template&id=c8986a18&scoped=true&"
import script from "./UnitWrapper.vue?vue&type=script&lang=js&"
export * from "./UnitWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8986a18",
  null
  
)

export default component.exports